import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Card, CardType } from '../../../../../_interfaces/cards.interface';
import { ActivatedRoute } from '@angular/router';
import { CardsApiService } from '../../../../../_services/cards-service/cards-api/cards-api.service';
import { BlockCardComponent } from '../../../../../shared/components/cards/block-card/block-card.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-block-subscription-card',
  imports: [BlockCardComponent],
  templateUrl: './block-subscription-card.component.html',
})
export class BlockSubscriptionCardComponent implements OnInit, OnDestroy {
  readonly route = inject(ActivatedRoute);
  readonly cardsApiService = inject(CardsApiService);

  private readonly cardId: number;
  protected cardDetails?: Card;
  protected cardType: CardType = CardType.Subscription;
  readonly subscriptions = new Subscription();

  constructor() {
    const route = this.route;

    this.cardId = route.snapshot.params['id'];
  }

  ngOnInit() {
    this.subscriptions.add(
      this.cardsApiService.getSubscriptionCardById(this.cardId).subscribe((data) => (this.cardDetails = data)),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
